<section class="legal">
  <div class="legal__wrap">
    <header class="legal__head">
      <span class="legal__tag">{{ t('legal.tag') }}</span>

      <nav class="legal__tabs" [attr.aria-label]="t('legal.tag')">
        <a routerLink="/user-agreement" routerLinkActive="active">{{ t('legal.agreementTab') }}</a>
        <a routerLink="/privacy-policy" routerLinkActive="active">{{ t('legal.privacyTab') }}</a>
        <a routerLink="/personal-data-consent" routerLinkActive="active">{{ t('legal.consentTab') }}</a>
      </nav>
    </header>

    <p class="legal__error" *ngIf="loadError" role="alert">{{ t('legal.loadError') }}</p>

    <div class="legal__body" *ngIf="doc">
      <!-- Содержание: на десктопе прилипает слева при прокрутке -->
      <aside class="legal__toc">
        <p class="legal__toc-title">{{ t('legal.contents') }}</p>
        <ol>
          <li *ngFor="let section of doc.sections">
            <a [href]="'#' + section.id" (click)="scrollTo($event, section.id)">{{ section.title }}</a>
          </li>
        </ol>
      </aside>

      <article class="legal__doc">
        <h1>{{ doc.title }}</h1>
        <p class="legal__date">{{ doc.dateLabel }}: {{ doc.date }}</p>
        <p class="legal__note" *ngIf="doc.note">{{ doc.note }}</p>

        <p class="legal__intro" *ngFor="let parts of doc.intro">
          <ng-container *ngTemplateOutlet="text; context: { $implicit: parts }"></ng-container>
        </p>

        <section *ngFor="let section of doc.sections" class="legal__section">
          <h2 [id]="section.id">{{ section.title }}</h2>

          <ng-container *ngFor="let block of section.blocks">
            <p *ngIf="block.kind === 'p'">
              <ng-container *ngTemplateOutlet="text; context: { $implicit: block.parts }"></ng-container>
            </p>

            <ul *ngIf="block.kind === 'list'">
              <li *ngFor="let item of block.items">
                <ng-container *ngTemplateOutlet="text; context: { $implicit: item }"></ng-container>
              </li>
            </ul>

            <dl *ngIf="block.kind === 'terms' || block.kind === 'fields'" [class.legal__fields]="block.kind === 'fields'">
              <div *ngFor="let row of block.rows">
                <dt>{{ row.term }}</dt>
                <dd><ng-container *ngTemplateOutlet="text; context: { $implicit: row.parts }"></ng-container></dd>
              </div>
            </dl>
          </ng-container>
        </section>
      </article>
    </div>
  </div>
</section>

<ng-template #text let-parts>
  <ng-container *ngFor="let part of parts">
    <a *ngIf="part.route" [routerLink]="part.route">{{ part.text }}</a>
    <a *ngIf="part.href" [href]="part.href">{{ part.text }}</a>
    <ng-container *ngIf="!part.route && !part.href">{{ part.text }}</ng-container>
  </ng-container>
</ng-template>
